import { ca } from '@cian/analytics';

import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { IPromoInfo } from '../../../types/newbuildingPromos';
import { getProducts } from '../../../utils/tracking/get_products';
import { ISoprProducts } from '../../../utils/tracking/types';

interface ITrackPromoOffersShow {
  offer: IOfferSchema;
  promos: IPromoInfo[];
  isMortgagePromos: boolean;
}

export function trackPromoOffersShow({ promos, offer, isMortgagePromos }: ITrackPromoOffersShow) {
  const promoId = promos.map((promo, idx) => ({
    promo_type: promo.promoType,
    promo_id: promo.promoId,
    position: idx + 1,
  }));

  const extra = { promoId };
  const products: ISoprProducts = getProducts({ agent: null, offer, kpId: null, extra });

  const label = isMortgagePromos ? 'mortgage_offers' : 'promo_offers';

  ca('eventSite', {
    action: 'show_sopr',
    category: 'Promo',
    name: 'oldevent',
    products: [products],
    label,
  });
}
